export const CtxSegmentStates = {
  NEW: 0,
  STAGING: 1,
  STAGED: 2,
  FAILED_STAGING: 3,
};
